<template>
    <img
        v-if="getMediaType === 'image' && media !== '//'"
        :src="media"
        :class="this.class"
        :alt="title"
        :title="title"
        :loading="loading"
        @load="$emit('load', $event)"
    >
    <video
        v-else-if="getMediaType === 'video' && media.video !== '//' && media.poster !== '//'"
        :class="this.class"
        :title="title"
        :poster="media.poster"
        :muted="!media.sound"
        :autoplay="media.autoplay"
        :playsinline="media.autoplay"
        :loop="media.loop"
        :controls="media.controls"
    >
        <source :src="media.video">
    </video>
</template>

<script>
import Page from '../../../../../../resources/frontend/js/mixins/page.vue';

export default {
    mixins: [Page],

    emits: ['load'],
    props: {
        path: {
            type: String,
            required: false,
        },

        item: {
            type: [Object, String],
            required: false,
        },

        class: {
            type: String,
            required: false,
            default: '',
        },

        title: {
            type: String,
            required: false,
            default: '',
        },

        lazyLoadingOnMobile: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            media: null,
        };
    },

    computed: {
        getMediaType() {
            if (!this.media) return '';

            if (this.media['video'] !== undefined && this.media['video'] !== null && this.media['video'] !== '') {
                return 'video';
            }

            if (typeof this.media === 'string' && this.media !== '' && this.media !== null) {
                return 'image';
            }

            return '';
        },

        loading() {
            if (this.lazyLoadingOnMobile && !window.matchMedia('(min-width: 1024px)').matches) {
                return 'lazy';
            }

            return '';
        },
    },

    mounted() {
        if (this.path) {
            this.media = this.get(this.path);
        } else if (this.item) {
            this.media = this.item;
        }

        // Don't get the image from cache if in preview and not a placeholder image
        if (typeof this.media === 'string' && this.$store.state.page.isPreview && this.mediaIsNotEmpty(this.media) && !this.media.includes('placeholder')) {
            this.media = this.media + '?t=' + Date.now();
        }
    },
};
</script>
